import { PlanDetails, PlanName } from '../_gen/gql'

const isPro = (plan: Pick<PlanDetails, 'name'>) =>
  plan.name === PlanName.Pro || plan.name === PlanName.Trial

export default {
  isPro,
}
